<template>
  <div class="footer_content">
    <div class="footer_content_top">
      <div>Copyright</div>
      <img src="@/assets/img/footerContent/C.png" alt="">
      <div>www.Amdox.com,All Rights Reserved.</div>
    </div>
    <div>助力智慧教育</div>
  </div>
</template>

<script>
export default {
  name: "FooterContent"
};
</script>

<style lang='less' scoped>
.footer_content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 100px;

  .footer_content_top {
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 12px;
      height: 12px;
      margin: 0 6px;
    }
  }

  div {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(135, 135, 135, 1);
    margin-bottom: 5px;
  }
}
</style>